"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncMetersFromDTMutation = exports.useDeleteMeterChangeEventMutation = exports.useFetchMeterAuditLogQuery = exports.useFetchMeterHistoryQuery = exports.useUpdateMeterMutation = exports.useDeleteMeterMutation = exports.useFetchMeterQuery = exports.useSearchMetersQuery = exports.useFetchMetersQuery = exports.useCreateMeterMutation = exports.meterApi = void 0;
// api/meterApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.meterApi = (0, react_1.createApi)({
    reducerPath: "meterApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["meters"],
    endpoints: function (builder) { return ({
        createMeter: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/meter/create",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["meters"],
        }),
        fetchMeters: builder.query({
            query: function (obj) { return ({
                url: "/v1/meter/all",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    meterType: obj.meterType,
                    responsibleParty: obj.responsibleParty,
                    isManualReading: obj.isManualReading,
                    deleted: obj.deleted,
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["meters"],
        }),
        searchMeters: builder.query({
            query: function (obj) {
                var params = {
                    clientId: obj.clientId,
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                if (obj.meterType)
                    params.meterType = obj.meterType;
                if (obj.buildingId)
                    params.buildingId = obj.buildingId;
                if (obj.areaId)
                    params.areaId = obj.areaId;
                if (obj.tenantId)
                    params.tenantId = obj.tenantId;
                if (obj.rateCard)
                    params.rateCard = obj.rateCard;
                if (obj.isManualReading !== undefined)
                    params.isManualReading = obj.isManualReading;
                if (obj.responsibleParty)
                    params.responsibleParty = obj.responsibleParty;
                if (obj.meterLevel)
                    params.meterLevel = obj.meterLevel;
                if (obj.source)
                    params.source = obj.source;
                return {
                    url: "/v1/meter/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["meters"],
        }),
        fetchMeter: builder.query({
            query: function (meterId) { return ({
                url: "/v1/meter/fetch",
                method: "GET",
                params: {
                    _id: meterId,
                },
            }); },
            providesTags: ["meters"],
        }),
        updateMeter: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/meter/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["meters"],
        }),
        deleteMeter: builder.mutation({
            query: function (_a) {
                var meterId = _a.meterId, meter_reading = _a.meter_reading, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/meter/remove",
                    method: "DELETE",
                    params: __assign({ _id: meterId, meter_reading: meter_reading, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["meters"],
        }),
        fetchMeterHistory: builder.query({
            query: function (meterId) { return ({
                url: "/v1/meter/history",
                method: "GET",
                params: { _id: meterId },
            }); },
            providesTags: function (_result, _err, meterId) { return [{ type: "meters", id: "history:".concat(meterId) }]; },
        }),
        fetchMeterAuditLog: builder.query({
            query: function (_a) {
                var meterId = _a.meterId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/meter/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: meterId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "meters", id: "audit:".concat(arg.meterId) }]; },
        }),
        deleteMeterChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/meter/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "meters", id: "audit:".concat(arg.meterId) },
                { type: "meters", id: "history:".concat(arg.meterId) },
            ]; },
        }),
        syncMetersFromDT: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/meter/sync-digital-twin",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["meters"],
        }),
    }); },
});
exports.useCreateMeterMutation = exports.meterApi.useCreateMeterMutation, exports.useFetchMetersQuery = exports.meterApi.useFetchMetersQuery, exports.useSearchMetersQuery = exports.meterApi.useSearchMetersQuery, exports.useFetchMeterQuery = exports.meterApi.useFetchMeterQuery, exports.useDeleteMeterMutation = exports.meterApi.useDeleteMeterMutation, exports.useUpdateMeterMutation = exports.meterApi.useUpdateMeterMutation, exports.useFetchMeterHistoryQuery = exports.meterApi.useFetchMeterHistoryQuery, exports.useFetchMeterAuditLogQuery = exports.meterApi.useFetchMeterAuditLogQuery, exports.useDeleteMeterChangeEventMutation = exports.meterApi.useDeleteMeterChangeEventMutation, exports.useSyncMetersFromDTMutation = exports.meterApi.useSyncMetersFromDTMutation;
